/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

//styles
import { Colors } from "../../styles";

const RiverCard = ({ riverItem, isSmall }) => {
	const renderTags = () => {
		if (riverItem.regions.length > 0) {
			return riverItem.regions.map((region) => {
				return <Tag key={region.slug}>{region.title}</Tag>;
			});
		}
	};
	return (
		<Card>
			<div className="top-part">
				<a href={riverItem.url} aria-label={`link to ${riverItem.title} page`}>
					<AspectRatioBox isSmall={isSmall}>
						<img
							src={
								riverItem.image
									? riverItem.image
									: `${mainScript.assetPath}images/png/logos/ar-placeholder@2x.png`
							}
							alt={
								riverItem.image
									? `${riverItem.title} river image`
									: "American Rivers placeholder image"
							}
						/>
					</AspectRatioBox>
				</a>
				<div>
					<TagContainer>{renderTags()}</TagContainer>
					<a href={riverItem.url}>
						<Title dangerouslySetInnerHTML={{ __html: riverItem.title }} />
					</a>
				</div>
			</div>
		</Card>
	);
};

export default RiverCard;

RiverCard.propTypes = {
	riverItem: PropTypes.object,
	isSmall: PropTypes.bool
};

const Card = styled.li`
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	a {
		&:after {
			content: unset;
		}
	}
`;

const AspectRatioBox = styled.div`
	position: relative;
	width: 100%;
	display: block;
	overflow: hidden;
	padding-top: ${(props) =>
		props.isSmall ? "calc(162 / 299 * 100%)" : "calc(220 / 406 * 100%);"};
	border-radius: 10px;
	z-index: 2;

	> img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		border-radius: 10px;
		transition: transform 0.5s ease-out;

		&:hover {
			transform: scale(1.1);
		}
	}
`;

const TagContainer = styled.div`
	position: relative;
	z-index: 2;
	padding-top: 1.5rem;
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
`;

const Tag = styled.span`
	position: relative;
	z-index: 2;
	padding: 0 0.7rem;
	font-weight: 700;
	font-size: 1.1rem;
	line-height: 2.8rem;
	text-transform: uppercase;
	width: fit-content;
	border-radius: 2px;
	color: ${Colors.base.black};
	background-color: ${Colors.riverBlue.base};
`;

const Title = styled.h3`
	position: relative;
	z-index: 2;
	padding-top: 1rem;
	font-size: 1.8rem;
	line-height: 2.4rem;
	text-transform: uppercase;
	color: ${Colors.base.white};
`;
